import React, {Component} from 'react';
import {Redirect} from 'react-router-dom'
import Navbar from "../Navbar/Navbar";
import './Home.css';
import styled from 'styled-components';

//@TODO Protect Private Routes

export default class Home extends Component {
    state = {
        arra: [],
        loginState: false
    };

    componentDidMount() {
        document.title = 'Home';
    }

    // constructor(props){
    //     super(props);
    //     this.addRef = React.createRef()
    // }

    redirectToLogin = () => {
        if (localStorage.getItem('uuid') === 'undefined' || localStorage.getItem('uuid') === null) {
            return (<Redirect to='/'/>);
        }
    };

    registerUser=()=> {
        fetch(`https://py-switches.herokuapp.com/graphql?query=mutation{CreateUser(uuid:"${localStorage.getItem('uuid')}"){uuid}}`, {method: 'POST'});
    };
    render() {
        const Head2 = styled.h1`
  font-size: 1.5em;
  text-align: center;
  color: palevioletred;
`;
        const Wrapper = styled.section`
  padding: 4em;
  background: papayawhip;
`;
//         const Wrapper2 = styled.section`
//   padding: 4em;
//   background: pink;
// `;

        return (
            <div>
                {this.registerUser()}
                {this.redirectToLogin()}
                <Navbar activeClass='Home'/>
                <div className='row'>
                    <div className='col-lg-12'>
                </div>
                </div>
                <div className='row'>
                    <div className='col-md-12 col-md-4'>
                        <div id="carouselExampleControls" data-interval = "6000" className="carousel slide" data-ride="carousel">
                            <div className="carousel-inner">
                                <div className="carousel-item active" style={{'textAlign':'center'}}>
                                    <Wrapper>
                                        <Head2 className='bounceInUp animated'>PY-PLOTS-MAPS</Head2>
                                    </Wrapper>
                                    {/*<Wrapper2>*/}
                                    {/*</Wrapper2>*/}
                                </div>
                                <div className="carousel-item">
                                    <Wrapper>
                                        <Head2 className='bounceInUp animated'>PLOTS</Head2>
                                    </Wrapper>
                                </div>
                                <div className="carousel-item">
                                    <Wrapper>
                                        <Head2 className='bounceInUp animated'>MAPS</Head2>
                                    </Wrapper>
                                </div>
                            </div>
                            <a className="carousel-control-prev" href="#carouselExampleControls" role="button"
                               data-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"> </span>
                                <span className="sr-only">Previous</span>
                            </a>
                            <a className="carousel-control-next" href="#carouselExampleControls" role="button"
                               data-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"> </span>
                                <span className="sr-only">Next</span>
                            </a>
                        </div>
                </div>

                </div>
            </div>);
    }
}
